import css from 'styled-jsx/css';
import { MQ_MEDIUM, MQ_MIDLARGE } from 'constants/mq';
import { sharedPalette, warmGrays } from 'styles/colors/constants';

export default css`
  .RecipeFirstStickyNav__body {
    background: #f5f3f3;
    padding: 1rem 1rem 0.5rem;
  }

  .RecipeFirstStickyNav__intro {
    display: flex;
    flex: 1 0 auto;
  }

  .RecipeFirstStickyNav__smallLogo :global(svg) {
    width: 1.5rem;
    height: 1.5rem;
  }

  .RecipeFirstStickyNav__postTitle {
    color: black;
    margin-bottom: 0.85rem;
    font-size: 1.2rem;
  }

  .RecipeFirstStickyNav__info {
    display: flex;
    margin-bottom: 0;
    font-size: 0.75rem;
  }

  .RecipeFirstStickyNav__yieldLabel,
  .RecipeFirstStickyNav__timeLabel {
    font-style: italic;
    color: ${warmGrays[3]};
    font-weight: normal;
  }

  .RecipeFirstStickyNav__rating {
    margin-bottom: 0.5rem;
  }

  :global(.RecipeFirstStickyNav .RecipeRating .RecipeRating__rating) {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }

  :global(.RecipeFirstStickyNav .RecipeRating .RecipeRating__text) {
    text-transform: initial;
    display: block;
    font-size: 0.65rem;
    font-style: italic;
    color: ${warmGrays[3]};
  }

  :global(.RecipeFirstStickyNav .RecipeRating .RecipeRating__star) {
    width: 1rem;
  }

  .RecipeFirstStickyNav__info__yeild,
  .RecipeFirstStickyNav__time {
    font-weight: bold;
    text-align: left;
    margin-right: 1.5rem;
  }

  .RecipeFirst__actionButtons {
    display: flex;
  }

  :global(.RecipeFirstStickyNav .SitePostActions__actions) {
    justify-content: left;
    margin-bottom: 0;
  }

  :global(.RecipeFirstStickyNav .PrintButton__button) {
    background-color: ${sharedPalette.watermelon};
    border-radius: 1.5em;
    padding: 0.5em;
    margin: 0 0.25rem;
    color: white;
  }

  :global(.RecipeFirstStickyNav .PrintButton svg) {
    margin-right: 0;
  }

  .RecipeFirstStickyNav__actions {
    display: flex;
  }

  .RecipeFirstStickyNav__body--sticky {
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    padding: 0.25rem 1rem;
    filter: drop-shadow(2px 2px 6px #999);
    z-index: 10000000000; /* very large z-index to make sure it is higher than sticky video */
    background-color: #ffffff;
  }

  .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__container {
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 100;
    overflow-y: hidden;
    height: 32px;
    overflow: visible;
  }

  .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__smallLogo {
    display: inline;
    color: ${sharedPalette.kYellow};
    padding-top: 0.25rem;
    margin-right: 0.5rem;
  }

  .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__postTitle {
    font-size: 0.75rem;
    padding-top: 0.45rem;
    margin: auto;
  }

  .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__shareActions,
  .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__rating,
  .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__info {
    display: none;
  }

  .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__actions {
    position: absolute;
    right: 0;
    background: linear-gradient(
      270deg,
      rgba(245, 245, 245, 0) 0%,
      rgba(245, 245, 245, 0.8) 75%,
      rgba(245, 245, 245, 0.8) 99%
    );
    padding-left: 1rem;
  }

  .RecipeFirstStickyNav__smallLogo,
  .RecipeFirstStickyNav__mobileLinks {
    display: none;
  }

  .RecipeFirstStickyNav__saveToRecipeBoxActions {
    display: none;
  }

  .RecipeFirstStickyNav__saveToRecipeBoxActionsMobile {
    display: flex;
    align-items: flex-end;
    padding-right: 0.5rem;
  }

  @media screen and ${MQ_MEDIUM} {
    .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__mobileLinks {
      display: block;
      padding-top: 0.25rem;
    }

    .RecipeFirstStickyNav__infoContainer {
      display: flex;
      justify-content: space-between;
    }

    .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__mobileLinks a {
      color: #5b4746;
      margin: 0 1.5rem;
      font-size: 0.8rem;
      font-weight: 500;
    }

    .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__container {
      justify-content: space-between;
      margin: 0 1rem;
    }

    .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__smallLogo {
      margin-right: 0.45rem;
    }

    .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__postTitle {
      font-size: 1rem;
      padding-top: 0.25rem;
      margin-top: 0.1rem;
      margin-right: 1rem;
    }

    .RecipeFirstStickyNav__body--sticky
      .RecipeFirstStickyNav__saveToRecipeBoxActions {
      margin-right: 1rem;
    }

    .RecipeFirstStickyNav__actions {
      display: inherit;
    }

    .RecipeFirstStickyNav__saveToRecipeBoxActions {
      display: block;
    }

    .RecipeFirstStickyNav__saveToRecipeBoxActionsMobile {
      display: none;
    }

    :global(.RecipeFirstStickyNav .SitePostActions__actions) {
      margin-top: 0;
    }

    :global(.RecipeFirstStickyNav .SitePostActions__actions) {
      justify-content: center;
    }

    .RecipeFirstStickyNav__shareActions {
      position: relative;
      top: 1rem;
      z-index: 2;
    }
  }

  @media screen and ${MQ_MEDIUM} {
    .RecipeFirstStickyNav__rating {
      margin: 0 1rem;
    }
  }

  @media screen and ${MQ_MIDLARGE} {
    .RecipeFirstStickyNav__body {
      padding-bottom: 0;
    }

    .RecipeFirstStickyNav__info {
      min-width: 40%;
      margin-top: 0.5rem;
    }

    .RecipeFirstStickyNav__rating {
      margin: 0;
    }

    .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__rating {
      display: block;
      padding-top: 0.35rem;
      margin-bottom: 1rem;
    }

    .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__container {
      justify-content: inherit;
      width: 1200px;
      margin: 0 auto;
    }

    .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__intro {
      margin-right: 20%;
      margin-top: 0.45rem;
    }

    .RecipeFirstStickyNav__rating {
      margin-top: 0.5rem;
    }

    :global(.RecipeFirstStickyNav .RecipeRating .RecipeRating__star) {
      width: 1.3rem;
    }

    .RecipeFirstStickyNav__body--sticky
      .RecipeFirstStickyNav__saveToRecipeBoxActions {
      margin-top: 0.35rem;
      min-width: 8rem;
    }

    .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__mobileLinks {
      padding-top: 0.8rem;
    }

    .RecipeFirstStickyNav__body--sticky .RecipeFirstStickyNav__container {
      height: inherit;
    }
  }
`;
